import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from 'src/App';
import ScrollTop from 'src/hooks/useScrollTop';
import './styles/globals.css';
import * as serviceWorker from 'src/serviceWorker';

// npm run buildの際にconsole.log()を何もしないメソッドにすり替え
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ScrollTop />
    <App />
  </BrowserRouter>
);

serviceWorker.unregister();
